import React from 'react';
import { useNavigate } from 'react-router-dom';
import { addVenueToOrganization } from '../../../services/Http/Api';
import VenueForm from "../../global/Venue/VenueForm";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const VenueCreate = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSave = async (venueData) => {
        try {
            await addVenueToOrganization(venueData);
            navigate('/venues');
        } catch (error) {
            console.error('Error adding venue:', error);
        }
    };

    return (
        <Container>
            <Header>
                <Title>{t('Venues.VenueForm.title_create')}</Title>
            </Header>
            <VenueForm onSave={handleSave} />
        </Container>
    );
};

export default VenueCreate;

const Container = styled.div`
    padding: 1.25rem;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
        padding: 0.625rem;
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.9375rem;
    margin-bottom: 1.25rem;
    border-bottom: 2px solid rgba(130, 22, 146, 0.8);
`;

const Title = styled.h1`
    font-size: 1.8rem;
    color: rgba(130, 22, 146, 1);
    margin: 0;

    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
`;
